<!--  -->
<template>
  <div class="history-contrast container">
    <el-form :model="formData" ref="formDom" class="form-content" size="small">
      <div class="commodity-list">
        <div class="title">供应商历史报价一览表</div>
        <div class="enquiry-form">
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="询价单名称：" prop="enquiryName">
                <span>{{ formData.enquiryName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="询价类型：" prop="enquiryType">
                <span>
                  {{
                    formData.enquiryType === 0
                      ? '定向询价'
                      : formData.enquiryType === 1
                      ? '公开询价'
                      : ''
                  }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="报价开始时间：" prop="releaseTime">
                <span>{{ formData.releaseTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="报价截止时间：" prop="quotationDeadline">
                <span>{{ formData.quotationDeadline }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
    <div class="table-box">
      <el-table
        max-height="660"
        :data="tableData"
        border
        :span-method="arraySpanMethod"
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <el-table-column
          prop="productName"
          label="商品名称"
          min-width="320"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="specifications"
          label="规格型号"
          min-width="320"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="supplierCompany"
          label="报价供应商"
          align="center"
          min-width="200"
        ></el-table-column>
        <el-table-column
          prop="requiredQuantity"
          label="需求数量"
          min-width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="unitName"
          label="计量单位"
          min-width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="price"
          label="报价单价（含税）"
          min-width="140"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="taxRate"
          label="税率（%）"
          min-width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="totalPrice"
          label="小计"
          min-width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="报价日期"
          min-width="180"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
    <div class="handle-button">
      <div class="btn back-btn" @click="goBack">
        < 返回
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/enquiry/index';
export default {
  data() {
    return {
      formData: {},
      tableData: [],
      needMergeArr: ['productName'], // 有合并项的列
      rowMergeArrs: {}, // 包含需要一个或多个合并项信息的对象
    };
  },
  components: {},
  mounted() {
    this.getHistoryData();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async getHistoryData() {
      try {
        const { enquiryId } = this.$route.query;
        const result = await Api.queryHistoryListPage({ enquiryId });
        const data = result.data;
        this.tableData = [...data.supplierOfferDetailQueryList];
        this.formData = { ...data.enquiry };
        this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, this.tableData); // 处理数据
        console.log(this.rowMergeArrs, 'this.rowMergeArrs');
      } catch (err) {
        console.log(err);
      }
    },

    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 没办法循环判断具体是那一列 所以就只好写了多个if
      if (column.property === 'productName')
        return this.mergeAction('productName', rowIndex, column);

      // 如果一下子合并多个，那么就写多个判断， 如果只有一个就写一个判断
      /* if (column.property === "id")
        return this.mergeAction("id", rowIndex, column); */
    },

    mergeAction(val, rowIndex, colData) {
      let _row = this.rowMergeArrs[val].rowArr[rowIndex];
      let _col = _row > 0 ? 1 : 0;
      return [_row, _col];
    },

    rowMergeHandle(arr, data) {
      if (!Array.isArray(arr) && !arr.length) return false;
      if (!Array.isArray(data) && !data.length) return false;
      let needMerge = {};
      arr.forEach(i => {
        needMerge[i] = {
          rowArr: [],
          rowMergeNum: 0,
        };
        data.forEach((item, index) => {
          // 表格首个数据单独处理
          if (index === 0) {
            needMerge[i].rowArr.push(1);
            needMerge[i].rowMergeNum = 0;
          } else {
            // 如果后一项与前一项相等，只用改变 rowArr 数组，不用管 rowMergeNum 数值
            if (item[i] === data[index - 1][i]) {
              // 后一项name与前一项name对比
              needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1; //此处是 rowMergeNum 属性存在的意义，就是为了定位要改变的数值
              needMerge[i].rowArr.push(0);
            }
            //如果后一项与前一项不相等，rowArr、rowMergeNum都改变
            else {
              needMerge[i].rowArr.push(1);
              needMerge[i].rowMergeNum = index;
            }
          }
        });
      });
      return needMerge;
    },
  },
};
</script>
<style lang="scss" scoped>
.history-contrast {
  background: #fff;
  padding: 20px;
  margin-left: 10px;
  .commodity-list {
    border: 1px solid #f5f5f5;
    &:last-child {
      margin-top: 10px;
    }

    .title {
      height: 50px;
      line-height: 50px;
      background: #f5f5f5;
      padding-left: 20px;
      text-align: center;
      color: #333333;
      font-size: 20px;
    }
    .commodity-content {
      padding: 0 10px 10px 10px;
      .set-type {
        line-height: 52px;
        i {
          font-size: 20px;
          cursor: pointer;
          &:hover {
            color: #2587ff;
          }
        }
      }
      .handle-btn {
        margin: 10px 0;
        .el-button {
          border-radius: 0;
        }
      }
      .table-content {
        .del-btn {
          color: #f0250f;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        ::v-deep .el-table th.must div:before {
          content: '*';
          color: #ff1818;
        }
        .edit-input {
          ::v-deep .el-input__inner {
            border-radius: 0;
          }
        }
      }

      .table-handle-btn {
        color: #0064c8;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      .err-btn {
        color: #f0250f;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }

      .add-table-handle-btn {
        margin-top: 10px;
        line-height: 38px;
        text-align: center;
        border: 1px dotted #d9d9d9;
        span {
          cursor: pointer;
        }
      }
    }
    .enquiry-form {
      padding-top: 20px;
      ::v-deep .el-select {
        width: 100%;
      }
      ::v-deep .el-date-editor.el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-textarea {
        width: 80%;
        .el-textarea__inner {
          border-radius: 0;
        }
      }

      .address-btn {
        color: #0064c8;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .table-box {
    margin-top: 10px;
    .table-handle-btn {
      color: #0064c8;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .err-btn {
      color: #f0250f;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .handle-button {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .back-btn {
      color: #333;
      border: 1px solid #dcdfe6;
    }
    .btn {
      min-width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      padding: 0 10px;
      cursor: pointer;
    }
    .right-btn {
      display: flex;
    }
    .reset-btn {
      background: #e8efff;
      border: 1px solid #2587ff;
      color: #2587ff;
      margin-right: 30px;
      line-height: 27px;
      &:hover,
      :active {
        background-color: #126edf;
        color: #fff;
      }
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
}
</style>
